export enum PolizaTipo {
    RESPONSABILIDAD_CIVIL = 'RESPONSABILIDAD_CIVIL'
}
